import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { Markdown, MarkdownElement } from '@/types/fields';

interface Props {
  readonly content: Markdown;
}

export const MarkdownView: React.FC<Props> = (props: Props): React.ReactElement => {
  const { content: elements } = props;

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      {elements.map((element: MarkdownElement, index: number): React.ReactElement => {
        switch (element.type) {
          case 'p':
            return (
              <Typography key={index} color="custom.LightGray">
                {element.content}
              </Typography>
            );
          case 'list':
            return (
              <Box key={index}>
                <Typography color="custom.LightGray">Sample responses</Typography>
                <List sx={styles.list}>
                  {element.items.map(
                    (item: string): React.ReactElement => (
                      <ListItem key={item} sx={styles.item} disableGutters={true}>
                        <Typography color="custom.LightGray">{item}</Typography>
                      </ListItem>
                    ),
                  )}
                </List>
              </Box>
            );
        }
      })}
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  list: { listStyleType: 'disc', ml: 3, color: 'custom.LightGray' },
  item: { display: 'list-item', padding: 0 },
};
